import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.62136 21.9988H1.99878V18.3762C1.99878 17.5806 2.31485 16.8175 2.87746 16.2549L5.0354 14.097L9.90063 18.9622L7.74269 21.1201C7.18008 21.6828 6.41701 21.9988 5.62136 21.9988Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.3148 17.548L22.5308 6.33202L17.6656 1.4668L6.44962 12.6828L11.3148 17.548Z"}}]};

const PenBrushFilled = Vue.extend<IconProps>({
  name: 'PenBrushFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pen-brush-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PenBrushFilled;
